__turbopack_context__.v({
  "optionChainTabs": "OptionTabs-module-scss-module__EqYl3G__optionChainTabs",
  "optionTab": "OptionTabs-module-scss-module__EqYl3G__optionTab",
});
